import { Rols } from "../types/userRol";

export const rolTypeActive = (rol = 0) => {
	let isAdmin = false;
	let isSuperAdmin = false;
	let isViewer = false;
	let isUser = false;
	//* USER
	if (rol === Rols.user) {
		isUser = true;
	}
	//* Super admin
	if (rol === Rols.superadmin) {
		isSuperAdmin = true;
	}
	//* Admin
	if (rol === Rols.admin) {
		isAdmin = true;
	}
	//* VIEWER
	if (rol === Rols.viewer) {
		isViewer = true;
	}
	return [isAdmin, isSuperAdmin, isViewer, isUser];
};
